module.exports = __webpack_public_path__ + "static/media/webcam.0c52c4a0.png";